import classNames from 'classnames';
import { useMemo } from 'react';
import { useAnchorable } from '../../hooks/useAnchorable';
import { column, growColumn } from './Column.css';
import { columns, stack } from './Columns.css';
import type { TColumnProps, TColumnsProps } from './Columns.types';
import { calculateAutoColumnWidth } from './calculateAutoColumnWidth';
import { usePostColumnsContext } from './context';
import { PostColumnsProvider } from './provider';

export const PostColumns = (props: TColumnsProps) => {
  const { children, element } = props;
  const { stackOnMobile, layout } = element.attrs || {};

  const { anchorAttributes } = useAnchorable(element.attrs);

  const autoColumnWidth = calculateAutoColumnWidth(element.content || []);

  return (
    <PostColumnsProvider layout={layout} autoColumnWidth={autoColumnWidth}>
      <div {...anchorAttributes} className={classNames(columns, stackOnMobile && stack)}>
        {children}
      </div>
    </PostColumnsProvider>
  );
};

export const PostColumn = (props: TColumnProps) => {
  const { layout: columnsLayout, autoColumnWidth: columnsAutoColumnWidth } = usePostColumnsContext();
  const { children, element } = props;
  const { position, width } = element.attrs || {};

  const columnWidth = useMemo(() => {
    // Backwards compatibility
    if (columnsLayout === 'sidebar-left' && position === 'left') {
      return '40%';
    }

    // Backwards compatibility
    if (columnsLayout === 'sidebar-left' && position === 'right') {
      return '60%';
    }

    // Backwards compatibility
    if (columnsLayout === 'sidebar-right' && position === 'left') {
      return '60%';
    }

    // Backwards compatibility
    if (columnsLayout === 'sidebar-right' && position === 'right') {
      return '40%';
    }

    if (width !== undefined) {
      return `${Math.min(Math.max(width, 10), 80)}%`;
    }

    return columnsAutoColumnWidth !== undefined ? `${columnsAutoColumnWidth}%` : undefined;
  }, [columnsLayout, columnsAutoColumnWidth, position, width]);

  return (
    <div className={classNames(column, columnWidth && growColumn)} style={{ width: columnWidth }}>
      {children}
    </div>
  );
};
